// component root 节点的布局

import { set_width, set_height } from "../size/size";
import merge from "lodash.merge";

const container = layer => {
  const size = layer.position.size;

  return merge(set_height(size.y.default, size.y.max, size.y.min), set_width(size.x.default, size.x.max, size.x.min));
};

export default container;
